export const LAYER_DISPLAY_ORDER = Object.freeze([
    'facility-zones',
    'process-flow',
    'key-solutions',
]);

export const LAYER_ID_TO_SLUG = Object.freeze({
    1: 'facility-zones',
    2: 'process-flow',
    3: 'key-solutions',
});

export const FILTER_CONFIG = Object.freeze({
    SOLUTIONS_LAYER_ID: 'key-solutions',
    FACILITY_ZONES_LAYER_ID: 'facility-zones',
    PROCESS_FLOW_LAYER_ID: 'process-flow',

    EXCLUDED_PORTFOLIOS: {
      MOBILE: [],
      DESKTOP: [1, 7, 8],
    },
    
    SPECIAL_PORTFOLIOS: [7, 8],
    
    MOBILE_BREAKPOINT: 768,
    
    DIMENSIONS: {
      COLLAPSED_HEIGHT: 'h-9',
      EXPANDED_HEIGHT_SOLUTIONS: 'h-125 md:h-104',
      EXPANDED_HEIGHT_OTHER: 'h-24',
      WIDTH: 'w-60 md:w-73',
    },
  });